import type { GraphQLFormattedError } from "graphql";
import { silently, track } from "./analytics";

/** The `extensions.code` the backend puts on a credit-limit error. */
const CREDIT_LIMIT_CODE = "credit_limit_reached";

let lastTrackedPathname: string | undefined;

/**
 * Sends `billing.credit_limit.hit` for a response carrying the credit-limit
 * error. One click fires several batched queries that each fail with it, so
 * the event goes out once per page: again only after the path has changed.
 * `pathname` is a getter so reading it happens inside `silently` too.
 */
export const trackCreditLimitHit = (
  errors?: ReadonlyArray<GraphQLFormattedError> | null,
  pathname?: () => string | undefined,
): void =>
  silently(() => {
    const hit = errors?.some(
      (candidate) => candidate?.extensions?.code === CREDIT_LIMIT_CODE,
    );
    if (!hit) return;

    const page = pathname?.() ?? "";
    if (page === lastTrackedPathname) return;
    lastTrackedPathname = page;

    track("billing.credit_limit.hit");
  });
